import React from "react";
import fondo3 from "../../../assets/img/promocionBlustay/fondo3.png";
const Herramientas = () => {
    return (
        <div className="relative w-full">
            {/* Fondo con altura fija */}
            <img
                src={fondo3}
                alt="fondo3"
                className="w-full md:h-[400px] h-[350px] object-cover"
            />

            {/* Contenido sobre el fondo */}
            <div className="absolute top-8 left-0 w-full flex flex-col justify-start items-center text-white">
                <div className="text-lg md:text-2xl font-bold text-center mx-auto mt-3 uppercase">
                    Todo esto y mucho mas herramientas con blustay conócelas
                    completamente gratis
                </div>

                <div className="flex flex-col gap-3 justify-center items-center text-gray-900 mt-7">
                    <div className="bg-white md:w-72 w-60 md:py-3 py-2 text-sm uppercase rounded-full text-center md:text-lg font-semibold">
                        Integraciones con Ota´s
                    </div>

                    <div className="bg-white md:w-72 w-60 md:py-3 py-2 text-sm uppercase rounded-full text-center md:text-lg font-semibold">
                        CRM inteligente
                    </div>
                    <div className="bg-white md:w-72 w-60 md:py-3 py-2 text-sm uppercase rounded-full text-center md:text-lg font-semibold">
                        Servicios complementarios
                    </div>
                </div>
            </div>

            <div className="absolute bottom-0 w-full flex justify-center items-center">
                <div className=" rounded-t-lg px-5 bg-[#C3EA43] py-1.5 md:py-2 md:text-lg text-base font-semibold  ">
                    y más...
                </div>
            </div>
        </div>
    );
};

export default Herramientas;
